import { useTranslations } from "@/lib/static-intl";
import EmptyState from "@/components/empty-state";
import AddPlaceButton from "../add-place-button";

const NoPlacePlaceholder = ({ openPlaceAddModal = () => {} }) => {
  const t = useTranslations("places");
  return (
    <div className="w-full h-full flex flex-col items-center justify-center">
      <EmptyState icon="lucide:map-pin" title={t("no place avaiable")} />
      <div className="text-center text-xs text-black/40 dark:text-white/40 -mt-1">
        <AddPlaceButton openPlaceAddModal={openPlaceAddModal} />
      </div>
    </div>
  );
};

export default NoPlacePlaceholder;
